(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PurchasePresentItemDialogController', PurchasePresentItemDialogController);

    PurchasePresentItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PurchasePresentItem', 'Purchase', 'Product', 'PresentListProduct'];

    function PurchasePresentItemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PurchasePresentItem, Purchase, Product, PresentListProduct) {
        var vm = this;
        vm.purchasePresentItem = entity;
        vm.purchases = Purchase.query();
        vm.products = Product.query();
        vm.presentlistproducts = PresentListProduct.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:purchasePresentItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.purchasePresentItem.id !== null) {
                PurchasePresentItem.update(vm.purchasePresentItem, onSaveSuccess, onSaveError);
            } else {
                PurchasePresentItem.save(vm.purchasePresentItem, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
